import { render, staticRenderFns } from "./Registerec.vue?vue&type=template&id=0d24ac7e&scoped=true&"
import script from "./Registerec.vue?vue&type=script&lang=js&"
export * from "./Registerec.vue?vue&type=script&lang=js&"
import style0 from "./Registerec.vue?vue&type=style&index=0&id=0d24ac7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d24ac7e",
  null
  
)

export default component.exports